module.exports = __webpack_public_path__ + "img/title.05b58b9.png";